export const WSS_URL = 'wss://webrtc.macrovoip.it:7443';
